import { render, staticRenderFns } from "./CustomToast.vue?vue&type=template&id=4a87061f&"
import script from "./CustomToast.vue?vue&type=script&lang=js&"
export * from "./CustomToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports